import { Buffer } from 'buffer';

import { FORMAT_NAME } from './format';
import { Song } from './song';
import { Player } from './player';
import { Sample } from './sample';
import { Ornament } from './ornament';
import { Pattern } from './pattern';

let SoundtrackerEngine = {
    name: FORMAT_NAME,
    displayName: 'Soundtracker',
    description: 'ZX Spectrum, 3 channels',
    Song: Song,
    Player: Player,
    Sample: Sample,
    Ornament: Ornament,
    Pattern: Pattern,
    canImport: (file) => {
        return file.name.match(/\.stc$/i);
    },
    import: (file) => {
        return file.arrayBuffer().then((arrayBuffer) => {
            return Song.fromSTC(Buffer.from(arrayBuffer));
        });
    },
};

export { SoundtrackerEngine };
